import { z } from 'zod';
import { createToolSignature } from './tool-signature';

export const updateWorkingMemoryToolSignature = createToolSignature({
    name: 'updateWorkingMemory',
    description: 'Update the working memory of the current user.',
    inputSchema: z.any(),
    outputSchema: z.object({
        success: z.boolean(),
    }),
    toolCallUi: (input) => `Updating memory`,
});
